import React, { useState, useEffect } from 'react';

const Togbutton = ({ id, status }) => {
  const [isOn, setIsOn] = useState(status === 1);

  useEffect(() => {
    setIsOn(status === 1);
  }, [status]);

  const handleToggle = async () => {
    const newState = !isOn;
    const burl = process.env.NEXT_PUBLIC_API;
    setIsOn(newState);

    try {
      await fetch(`${burl}/hidden.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id, listed: newState ? '1' : '0' }),
      });
    } catch (error) {
      console.error('Error posting toggle state:', error);
    }
  };

  return (
    <button
      onClick={handleToggle}
      className={`relative w-14 h-8 flex items-center rounded-full transition-colors duration-300 ${
        isOn ? 'bg-green-500' : 'bg-gray-400'
      }`}
    >
      <div
        className={`absolute left-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300 ${
          isOn ? 'translate-x-6' : 'translate-x-0'
        }`}
      />
    </button>
  );
};

export default Togbutton;
